<template>
  <div class="phone">
    <el-input placeholder="请输入电话号码" v-for="(item, index) in attrValue" :key="index" v-model="item.telNum" class="v-input">
      <el-select style="width: 80px;" v-model="item.name" slot="prepend" placeholder="请选择">
        <el-option v-for="type in phoneType" :value="type" :key="type"></el-option>
      </el-select>
      <el-button @click="addTel" slot="append" v-if="index === 0" icon="el-icon-plus"></el-button>
      <el-button @click="delTel(index)" slot="append" v-if="index !== 0" icon="el-icon-minus"></el-button>
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    attrValue: {
      type: Array
    }
  },

  data () {
    return {
      phoneType: ['工作', '手机', '住宅', '主要', '传真', '其他']
    }
  },

  created () {
    this.updateValue()
  },

  methods: {
    addTel () {
      if (this.attrValue.length < 10) {
        this.attrValue.push({
          name: '工作',
          telNum: ''
        })
      }
    },
    delTel (index) {
      this.attrValue.splice(index, 1)
    },

    // 更新电话数据
    updateValue () {
      if (!this.attrValue || !this.attrValue.length) {
        let defaultVal = [
          {
            name: '工作',
            telNum: ''
          }
        ]
        this.$emit('update:attrValue', defaultVal)
      }
    }
  },

  watch: {
    attrValue () {
      this.updateValue()
    }
  }
}
</script>

<style lang="less" scoped>
  .phone {
    .v-input {
      width: 350px;
      margin-bottom: 8px;
    }
  }
</style>


// WEBPACK FOOTER //
// phone.vue?65c1faaf